import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'field-builder',
  template: `
  <div class="form-group col-md-offset-3 col-md-6" [formGroup]="form">
    <h3 *ngIf='field.title'> <i class="fa fa-dot-circle-o"></i> &nbsp;{{field.title}}</h3>
    <br>
    <label [attr.for]="field.name">
      {{field.name}}
      <strong class="text-danger" *ngIf="field.required">*</strong>
    </label>
    <div [ngSwitch]="field.type">
      <textbox *ngSwitchCase="'text'" [field]="field" [form]="form.get(field.name)"></textbox>
      <dropdown *ngSwitchCase="'dropdown'" [field]="field" [form]="form.get(field.name)"></dropdown>
      <checkbox *ngSwitchCase="'checkbox'" [field]="field" [form]="form.get(field.name)"></checkbox>
      <radio *ngSwitchCase="'radio'" [field]="field" [form]="form.get(field.name)"></radio>
      <textbox *ngSwitchCase="'date'" [field]="field" [form]="form.get(field.name)"></textbox>
      <!-- <textareas *ngSwitchCase="'textarea'" [field]="field" [form]="form" ></textareas> -->
      <!-- <span *ngIf="!isValid && isDirty" style="margin-top: 5px;margin-bottom: 10px;color: red;">{{field.label}} is required</span> -->
    </div>
  </div>
  `
})
export class FieldBuilderComponent implements OnInit {
  @Input() field:any;
  @Input() form:any;
  
  // get isValid() { return this.form.controls[this.field.name].valid; }
  // get isDirty() { return this.form.controls[this.field.name].dirty; }

  constructor() { }

  ngOnInit() {
    //console.log(this.field);
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/field-builder/field-builder.component.ts